export default __webpack_public_path__ + "static/media/whatsapp.47ebc998.svg";